import React from 'react';


const CardContent = (props) => {

    // console.log("props in carousel ::",props);

    return (
        <>
            <div className="cardContent">
                <div className="cardContentImg">
                    <img src={props.cardImage} alt=""/>
                </div>
                <div className="cardContentBody">
                    <h2> {props.cardTitle}</h2>
                    <p>
                    {props.cardDescription}
                    </p>
                </div>
            </div>
        </>
    );
}

export default CardContent;